// extracted by mini-css-extract-plugin
export default {"container":"viewSettlement_container__Ys4jD","content":"viewSettlement_content__ai20b"};